import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import config from './config'
import AsyncComputed from 'vue-async-computed'
import VeeValidate from 'vee-validate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCurrencyFilter from 'vue-currency-filter'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import moment from 'moment';
import VueFire  from 'vuefire';
import firebase from 'firebase/app';
import fbaseSdk from './plugins/firebase-sdk';
//import TawkTo from './plugins/tawk-to';

firebase.initializeApp(fbaseSdk);
Vue.config.productionTip = false
Vue.prototype.$config = config;
Vue.prototype.$moment = moment;
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(VueSweetalert2);
Vue.use(AsyncComputed);
Vue.use(VueCurrencyFilter, {
    symbol : '',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: false
});


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
